<template>
    <breadCrumbs title="Step Form Wizard" main="Form Layout" title1="Step Form Wizard" />
          <div class="container-fluid text-start">
            <div class="row">
                <SimpleWizard/>
            </div>
          </div>
</template>
<script>
import SimpleWizard from "./SimpleWizard.vue"
export default {
    components:{
        SimpleWizard
    }
}
</script>